var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alinhamento", class: { "color-background": _vm.color } },
    [
      _c(
        "el-collapse",
        {
          attrs: { accordion: "accordion" },
          model: {
            value: _vm.abaAtiva,
            callback: function($$v) {
              _vm.abaAtiva = $$v
            },
            expression: "abaAtiva"
          }
        },
        [
          _c(
            "el-collapse-item",
            {
              class: { "recuo-texto": _vm.recuo },
              attrs: { name: "colapse", title: _vm.titulo }
            },
            _vm._l(_vm.informacoes, function(informacao) {
              return _c(
                "div",
                [
                  _c("app-display", {
                    attrs: {
                      label: informacao.label,
                      content: informacao.data,
                      marginBottom: informacao.marginBottom
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f41c74c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f41c74c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDisplayColapse.vue
// module id = null
// module chunks = 